import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import AllProperties from '../Components/AllProperties'
import WhatsAppButton from '../Components/WhatsAppButton'

function Properties() {
    return (
        <>
            <Navbar />
            <div className="Properties-header">
                <h1>All Properties</h1>
                <p>
                    Home / <span className="active">Properties</span>
                </p>
            </div>
            <AllProperties />
            <WhatsAppButton/>
            <Footer />
        </>
    )
}

export default Properties